export default __webpack_public_path__ + "static/media/step4.09cf4893.png";